import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=d4dd2214&"
import script from "./TreeItem.vue?vue&type=script&lang=ts&"
export * from "./TreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./TreeItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports